import {
    ArrowUpTrayIcon,
    BanknotesIcon,
    BoltIcon,
    CurrencyDollarIcon,
    DocumentIcon,
    HomeIcon,
    ListBulletIcon,
    PresentationChartBarIcon,
    LifebuoyIcon,
    TicketIcon,
} from "@heroicons/react/24/outline";
import SidebarRail from "./SidebarRail";

// One row per destination; `divider: true` draws the hairline between groups.
const NAV_ITEMS = [
    { to: "/dashboard", match: "dashboard", label: "Dashboard", icon: HomeIcon },
    { to: "/automatic", match: "automatic", label: "Automatic", icon: BoltIcon, badge: "New" },
    { to: "/upload", match: "upload", label: "Upload", icon: ArrowUpTrayIcon },
    { divider: true },
    { to: "/my-files", match: "my-files", label: "My Files", icon: DocumentIcon },
    { to: "/my-ticket", match: "my-ticket", label: "My Tickets", icon: TicketIcon },
    { to: "/automatic-support", match: "automatic-support", label: "Automatic Support", icon: LifebuoyIcon },
    {
        to: "/my-credits-history",
        match: "my-credits-history",
        label: "My Credits History",
        icon: BanknotesIcon,
    },
    { divider: true },
    { to: "/price-list", match: "price-list", label: "Price List", icon: ListBulletIcon },
    { to: "/buy-credits", match: "buy-credits", label: "Buy Credits", icon: CurrencyDollarIcon },
    { divider: true },
    { to: "/gain", match: "gain", label: "Gain", icon: PresentationChartBarIcon },
];

const Sidebar = ({ isOpen, toggleSidebar }) => (
    <SidebarRail
        items={NAV_ITEMS}
        title="VDP Tuning Team"
        subtitle="ECU file service"
        isOpen={isOpen}
        toggleSidebar={toggleSidebar}
    />
);

export default Sidebar;
